<template>
  <div class="data_table_container flex-col">
    <div class="pagination flex-row justify-end">
      <div class="flex-row justify-end">
        <div class="q0"></div>
        <span class="tips">未完成</span>
        <div class="q1"></div>
        <span class="tips">已尝试</span>
        <div class="q2"></div>
        <span class="tips">已完成</span>
      </div>
      <div
        v-if="showPagination"
        class="pagination_btn flex-row"
      >
        <img
          class="label_left"
          referrerpolicy="no-referrer"
          src="../../assets/components/FigmaDDSSlicePNGd4c8b146c5e977ba18d058cd878be396.png"
          @click="handleClickPage(-1)"
        />
        <span class="text_pagination"
          >第{{ currentPage }}/{{
            Math.ceil(props.total / props.pageSize)
          }}页</span
        >
        <img
          class="label_right"
          referrerpolicy="no-referrer"
          src="../../assets/components/FigmaDDSSlicePNG909fa7b2d82f34f9422697337d76c62a.png"
          @click="handleClickPage(1)"
        />
      </div>
    </div>
    <div class="table_bg">
      <div class="table_header flex-row justify-start">
        <span
          v-for="header in props.headers"
          :key="header.key"
          class="header_cell"
          :style="header.style"
          >{{ header.label }}</span
        >
      </div>
      <div class="section_divider flex-col" />
      <div class="table_items_list flex-col justify-start">
        <div
          class="table_item_wrapper flex-row"
          :class="{ 'even-row': index % 2 === 0 }"
          v-for="(item, index) in props.items"
          :key="index"
          @click="handleItemClick(item)"
        >
          <span
            v-for="header in props.headers"
            :key="header.key"
            class="cell"
            :style="header.cellStyle"
          >
            <div v-if="header.key != 'statu'" class="cell_content">{{ item[header.key] }}</div>
            <div
              v-else
              :class="getWrapperClass(item[header.key])"
            ></div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted } from "vue"

const props = defineProps({
  /** 表头配置数组 [{ key: '字段名', label: '标题', style: '表头样式', cellStyle: '单元格样式' }] */
  headers: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every((header) => header.key && header.label)
    },
  },
  /** 表格数据数组 */
  items: {
    type: Array,
    required: true,
    default: () => [],
  },
  /** 是否显示条纹行 */
  striped: {
    type: Boolean,
    default: true,
  },
  showPagination: {
    type: Boolean,
    default: false,
  },
  total: {
    type: Number,
    default: 1,
  },
  pageSize: {
    type: Number,
    default: 1,
  },
})
const currentPage = ref(1)

const emit = defineEmits(["item-click"])

/** 处理列表项点击 */
const handleItemClick = (item) => {
  emit("item-click", item)
}

const getWrapperClass = (status) => {
  //0：未完成 1：已尝试 2：完成
  return "y" + (status + 1)
}

const handleClickPage = (page) => {
  currentPage.value += page
  if (currentPage.value < 1) {
    currentPage.value = 1
  } else if (currentPage.value > Math.ceil(props.total / props.pageSize)) {
    currentPage.value = Math.ceil(props.total / props.pageSize)
  } else {
    emit("page-change", currentPage.value)
  }
}
</script>

<style scoped>
.data_table_container {
  position: relative;
  width: 100%;
}

.table_bg {
  width: auto;
  height: auto;
  min-height: 32vw;
  background: #ffffff;
  border-radius: 0.83vw 0.83vw 0.83vw 0.83vw;
  margin-top: 0.89vw;
  padding-bottom: 1vw;
}

.table_header {
  width: 100%;
  height: 1.36vw;
  margin: 1.51vw 0 0 0;
}

.header_cell {
  min-width: 5vw;
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  color: rgba(112, 119, 126, 1);
  line-height: 1.05vw;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  height: 1.36vw;
  overflow-wrap: break-word;
}

.section_divider {
  background-color: rgba(217, 217, 217, 1);
  height: 0.11vw;
  margin-top: 0.84vw;
  width: 100%;
}

.table_items_list {
  width: 100%;
}

.table_item_wrapper {
  width: 100%;
  height: 4.17vw;
  cursor: pointer;
}

.table_item_wrapper:hover {
  background-color: rgba(205, 230, 255, 1);
}

.even-row {
  background-color: rgba(247, 251, 255, 1);
}

.cell {
  height: 4.17vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: center;
  line-height: 4.17vw;
  margin: 0;
}

.cell_content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pagination {
  position: relative;
}

.pagination_btn {
  margin-top: -0.11vw;
}

.label_left {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0;
  vertical-align: middle;
  cursor: pointer;
}

.text_pagination {
  width: auto;
  height: 1.36vw;
  overflow-wrap: break-word;
  color: rgba(64, 72, 80, 1);
  font-size: 1.04vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 1.05vw;
  margin: 0.05vw 0.3vw 0 0.3vw;
}

.label_right {
  width: 1.31vw;
  height: 1.25vw;
  margin: 0;
  vertical-align: middle;
  cursor: pointer;
}

.y0 {
  background-color: rgba(160, 174, 188, 1);
  border-radius: 50%;
  height: 2.6vw;
  width: 2.6vw;
  margin: 0.78vw 0 0 0;
}

.y1 {
  background-color: rgba(244, 164, 51, 1);
  border-radius: 50%;
  height: 2.6vw;
  width: 2.6vw;
  margin: 0.78vw 0 0 0;
}

.y2 {
  background-color: rgba(85, 195, 157, 1);
  border-radius: 50%;
  height: 2.6vw;
  width: 2.6vw;
  margin: 0.78vw 0 0 0;
}

.q0 {
  background-color: rgba(160, 174, 188, 1);
  border-radius: 50%;
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.2vw;
  margin-top: 0.15vw;
  margin-right: 0.5vw;
}

.q1 {
  background-color: rgba(244, 164, 51, 1);
  border-radius: 50%;
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.2vw;
  margin-top: 0.15vw;
  margin-right: 0.5vw;
}

.q2 {
  background-color: rgba(85, 195, 157, 1);
  border-radius: 50%;
  width: 1.05vw;
  height: 1.05vw;
  margin-top: 0.15vw;
  margin-right: 0.5vw;
}

.tips {
  width: 4vw;
  height: 1.1vw;
  overflow-wrap: break-word;
  color: rgba(34, 76, 123, 1);
  font-size: 0.83vw;
  font-family: Microsoft YaHei-Regular;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 0.84vw;
  margin-top: 0.2vw;
}
</style>
